import { UserService } from './../../services/user.service';
import {Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import * as L from 'leaflet';
import { FeatureGroup, featureGroup, LatLng} from 'leaflet';
import 'leaflet-spin';
import 'leaflet.locatecontrol';
// import { MaptilerLayer } from "@maptiler/leaflet-maptilersdk";
import {NgxSpinnerService} from 'ngx-spinner';
import {of, Subject, zip} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {MapService} from './map.service';
import {SharedService} from 'src/app/services/sharedService';
import { BaseComponent } from '../base.component';
 import {ShapeFileImportComponent} from './shape-file-Import.component';
import {ConfirmationDialogComponent} from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {InformationDialogComponent} from '../dialogs/information-dialog/information-dialog.component';

@Component({
  selector: 'app-map',
  templateUrl: 'map.component.html',
})
export class MapComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  @Input() public height = "100vh"
  @Output() mapReady: EventEmitter<any> = new EventEmitter()
  @Input() bbox
  @Output() selectedBuildingDetails = new EventEmitter<any>()
  selectedFeatureJson = {}
  @Output() myLocationLatLng = new EventEmitter<any>()
  @Output() selectedFeatureGeoJSON = new EventEmitter<any>()
  // @Output() selectedFeatureBBOX = new EventEmitter<any>()
  @Output() onBoundariesApply = new EventEmitter<any>()
  @Output() onBoundariesDelete = new EventEmitter<any>()
  @Output() onEditAttributes = new EventEmitter<any>()
  @Output() onShapeFileAttributes = new EventEmitter<any>()
  @Output() onShapeFileUpload = new EventEmitter<any>()
  @Input() buildingId
  @Input() featureId
  @Input() buildingIdsList
  @Input() findMyLocation = false
  @Input() registered = false
  @Input() withAttributes = false
  @Input() addMarker = false
  @Input() addPolygon = false
  @Input() editBuilding = false
  @Input() editLot = false
  @Input() editFeature = false
  @Input() addedFeatureId
  @Input() featureGeoJson
  @Input() layers
  @Input() childLayer
  @Input() viewMode = 'standard'
  @Input() registeredFilter

  @ViewChild('remoteShapeFileImport', {static: false})
  remoteShapeFileImport: ShapeFileImportComponent

  private fetchBuilding = new Subject<any>()
  user
  editRoleList= ['PROPERTIES_LECTEUR', 'FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR']
  deleteRoleList = ['PROPERTIES_EDITOR', 'ADMIN']
  createRoleList = ['AGENT_RECENSEUR','PROPERTIES_LECTEUR','FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR','MAYOR_TREASURER_AND_PROPERTIES_LECTEUR']
  uploadType = 'get_attributes'
  uploadLayer = this.sharedService.getLayer(this.sharedService.LAYER_LOT)
  uploadMappingBody
  polygon = {latlng:[], utm:[], dms:[], raw: []}

  strToLeafletBBox(bbox) {
    if (!bbox)
      return [new LatLng(environment.boundary[1], environment.boundary[0]),
        new LatLng(environment.boundary[3], environment.boundary[2])]
    else {
      let bboxParts = bbox.split(",")
      return [new LatLng(bboxParts[0].split(" ")[1], bboxParts[0].split(" ")[0]),
        new LatLng(bboxParts[1].split(" ")[1], bboxParts[1].split(" ")[0])]
    }
  }



  countryBounds: LatLng[] = [new LatLng(environment.boundary[1], environment.boundary[0]),
    new LatLng(environment.boundary[3], environment.boundary[2])]

  baseLayersTiles = environment.baseLayers.map( bL => L.tileLayer(bL.rasterTileUrl, {
    // opacity: 0.5,
    maxZoom: 19,
    attribution: bL.attribution,
    minZoom: 8
  }))
  // baseLayerOSM = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //   // opacity: 0.5,
  //   maxZoom: 19,
  //   attribution: '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
  // })
  //
  // baseLayerOSMNoBuildings = L.tileLayer(environment.mapTilerBaseLayerFiltered, {
  //   // opacity: 0.5,
  //   maxZoom: 19,
  //   attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
  // })

  /**
   * Vector Tiles (for instance, OSM without Buildings etc.)
   */
  // baseLayerMapTiler = new MaptilerLayer({
  //   apiKey: "XXXXXXXXXXXX",
  //   style: "0199169f-ce84-7c5e-823c-aa371d6ae591",
  //   attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
  // } );
  // buildingLayer = L.tileLayer.wms('http://mapservice.revenuedev.org/geoserver/CI/wms?maxFeatures=500', {
  //   tms: false,
  //   opacity: 0.5,
  //   transparent: true,
  //   maxZoom: 19,
  //   layers: 'CI:buildings_v',
  //   format: 'image/png',
  //   attribution: 'using GeoServer open geospatial information server'
  // })
  //
  // crs
  baseLayers
  options
  map
  loading

  initMap = false;

  drawItems: FeatureGroup = featureGroup();

  drawOptions

  customMarker(color='blue'){
    return new (L.Icon.extend({
      options: {
        iconUrl: `assets/img/marker-icon-${color}.png`,
        shadowUrl: null,
        iconSize: [25,25],
        iconAnchor: [5, 10]
      }
    }));
  }

  constructor(private mapService: MapService,
              private spinner: NgxSpinnerService,
              private sharedService: SharedService,
              private userService: UserService,
              public dialog: MatDialog,
            ) {
                super()
    this.fetchBuilding.pipe(debounceTime(1500))
      .subscribe(() => {
        this.getFeatureList()
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.map) {
      if (changes.bbox) {
        try {
          setTimeout(()=> {
            this.map.fitBounds(L.latLngBounds(this.strToLeafletBBox(this.bbox)))
          }, 50)
        }catch(e){}
      }
      if (changes.registeredFilter){
        this.fetchBuilding.next('')
      }
      if (changes.buildingId) {
        this.loadSingleBuilding(true)
      }
      if (changes.featureId){
        this.loadSingleFeature(true)
      }
      if (changes.featureGeoJson){
        try {
          this.populateShapeInstance({features: [{geometry: this.featureGeoJson}]})
        }catch(e){}
      }
      if (changes.layers){
        try {
          this.loadLayers()
        }catch(e){}
      }
      if (changes.childLayer){
        try {
          this.loadChildLayer()
        }catch(e){}
      }
    }
  }

  ngOnInit(): void {

    this.baseLayers = {}

    let i = 0
    this.baseLayersTiles.forEach(blT => {
      this.baseLayers[environment.baseLayers[i++].name] = blT
    })

    this.options = {
      layers: [
        this.baseLayers[environment.baseLayers[0].name]
      ],
      zoom: 8,
      center: L.latLngBounds(this.countryBounds).getCenter(),
      useCache: true,
      crossOrigin: true,
      maxBounds: L.latLngBounds(this.countryBounds),
      maxBoundsViscosity: 1,
      fitBounds: L.latLngBounds(this.countryBounds),
      // crs: CRS.EPSG3857
    };

    this.drawOptions = {
      position: 'topright',
      draw: {
        polygon: false,
        polyline: false,
        circle: false,
        rectangle: false,
        marker: false,
        circlemarker: false
      },

      edit: false
    };

    this.userService.getCurrentUser().subscribe(user => {
      this.user = user;
      if (!this.createRoleList.includes(this.user.role)) {
        if (this.addMarker) {
          this.drawOptions.draw.marker = {icon: this.customMarker()};
          this.drawOptions.edit = {featureGroup: this.drawItems};
        }

        if (this.addPolygon) {
          this.drawOptions.draw.polygon = true;
        }

        if (this.addPolygon || this.editBuilding || this.editFeature || this.editLot) {
          this.drawOptions.edit = {featureGroup: this.drawItems};
        }
      }
      this.initMap = true;
      const this_ = this;

      setTimeout(() => {
        if (this.featureGeoJson) {
          this.populateShapeInstance({features: [{geometry: this.featureGeoJson}]});
        }
        this.loadLayers();
        if (this.childLayer) {
          this.loadChildLayer();
        }
        if (this.editLot && !this.createRoleList.includes(this.user.role)) {
          const customControl = L.Control.extend({
            options: {
              position: 'topright',
            },
            onAdd: function(map) {
              const container = L.DomUtil.create('div', 'leaflet-control-locate leaflet-bar leaflet-control');
              const cont1 = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single');
              cont1.title = 'Upload Shape File';
              cont1.text = 'SHAPE';
              container.append(cont1);
              cont1.style.width = '50px';
              // cont1.style.height = '30px';
              container.onclick = function() {
                this_.uploadType = 'get_attributes';
                this_.remoteShapeFileImport.browseFile();
              };
              return container;
            }
          });
          this.map.addControl(new customControl());

          this.sharedService.submitShapeFileAttributesMappingFormSubject$.pipe(takeUntil(this.destroy$)).subscribe((mapping) => {
            this.uploadMappingBody = mapping;
            setTimeout(() => {
              this.remoteShapeFileImport.upload();
            }, 50);
          });
        }
      }, 100);
    });

    this.sharedService.closePropertyTaxFormSubject$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.selectedBuildingLayer?.removeFrom(this.map);
      this.drawItems?.clearLayers();
      if (this.editBuilding) {
        this.getFeatureList()
        this.loadLayers()
      }
      if (this.editLot)
        this.loadLayers()
    });

    this.sharedService.deleteBoundariesSubject$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.clearAll()
    })
  }

  clearAll(loadBuilding = false){
    /**
     * CLEAR EVERYTHING!
     */
    this.selectedBuildingLayer?.removeFrom(this.map)
    this.drawItems?.clearLayers()
    this.selectedFeatureJson = {}
    this.selectedBuildingDetails.next({})
    this.polygon.latlng = []
    this.featureGeoJson = {}
    this.map.closePopup()
    /********* ***********/
    this.loadLayers()
    if (loadBuilding){
      this.getFeatureList()
    }
  }

  divisionLayers = []
  mapControl

  makeEmptyLayers(){
    if (this.divisionLayers?.length){
      this.divisionLayers?.forEach(dl => {
        this.mapControl.removeLayer(dl)
        dl?.clearLayers()
      })
      this.divisionLayers = []
    }
  }

  loadLayers(){
    this.makeEmptyLayers()
    this.layers?.forEach( L => {
      this.mapService.getLayer$(L, this.getCurrentBbox()).subscribe(geoJson=> {
        if (geoJson['features']?.length) {
          let divLayer = this.createGeoJSONLayer(geoJson, this.sharedService.getLayerColor(L), null, false, L)
          this.mapControl.addOverlay(divLayer, geoJson?.['features']?.[0]?.properties?.name || L)
          divLayer.addTo(this.map)
          // @ts-ignore
          divLayer.addData(geoJson)
          this.divisionLayers.push(divLayer)
        }
      })
    })
  }

  loadChildLayer() {
    this.makeEmptyLayers()
    this.mapService.getLayer$(this.childLayer.layer, this.getCurrentBbox(), this.childLayer.parentId).subscribe(geoJson => {
      if (geoJson['features']?.length) {
        let divLayer = this.createGeoJSONLayer(geoJson, this.sharedService.getLayerColor(this.childLayer.layer), null, false);
        this.mapControl.addOverlay(divLayer, geoJson?.['features']?.[0]?.properties?.name || this.childLayer.layer);
        divLayer.addTo(this.map);
        // @ts-ignore
        divLayer.addData(geoJson);
        this.divisionLayers.push(divLayer);
      }
    });
  }

  // coordsToLatLng(coords) {
  //   let latlng = CRS.EPSG3857.unproject(L.point(coords[0], coords[1]))
  //   return latlng
  // };

  currentLocation = null
  @Input()
  loadBuildings = false
  @Input()
  showBuildingLayer = true

  onMapReady($event) {

    $event.attributionControl.setPrefix('RDF Maps')

    this.map = $event

    L.control.scale().addTo(this.map)

    this.map.on('overlayadd', (layer) => {
      if (layer.name === 'RDF Buildings'){
        this_.loadBuildings = true
        this_.fetchBuilding.next('')
      }
      if (layer.name === 'Registered'){
        this_.registered = true
        this_.fetchBuilding.next('')
      }
      if (layer.name === 'Property TAX'){
        this_.withAttributes = true
        this_.fetchBuilding.next('')
      }
    })

    this.map.on('overlayremove', (layer) => {
      if (layer.name === 'RDF Buildings'){
        this_.loadBuildings = false
      }
      if (layer.name === 'Registered'){
        this_.registered = false
      }
      if (layer.name === 'Property TAX'){
        this_.withAttributes = false
      }
    })

    // // @ts-ignore
    // const customButton = L.control({ position: 'topleft' });
    // customButton.onAdd = () => {
    //   const buttonDiv = L.DomUtil.create('div', 'button');
    //
    //   buttonDiv.innerHTML = `<button>Custom Button</button>`;
    //   buttonDiv.addEventListener('click', () => alert('me'))
    //   return buttonDiv;
    // };
    // customButton.addTo(this.map)


    if (this.findMyLocation)
      // @ts-ignore
      L.control.locate().addTo(this.map)

    let count = 0
    this.map.on('locationfound', (e)=> {
      count ++
      if (count < 2) {
        this.myLocationLatLng.next(e.latlng.lat + "," + e.latlng.lng)
        this.currentLocation = e.latlng.lat + "," + e.latlng.lng
        this.getFeatureList()
      }
    });

    this.map.on('locationerror', (e)=> {
      count = 0
    });

    this.map.on('locatedeactivate', (e)=>{
      this.currentLocation = null
      count = 0
    })

    // this.map.on('locateactivate', (e)=>{
    // });

    this.mapControl = L.control.layers(this.baseLayers, {}, {
      collapsed: false,
      position: "topright",
      hideSingleBase: false
    }).addTo(this.map)

    // setTimeout(
    // this.mapControl.addOverlay(this.buildingLayer, "Buildings")
    //   , 10)

    if (this.buildingId){

      // this.mapService.getFeatureById$(this.buildingId).subscribe( geoJson => {
      //   this.createGeoJSONLayer(geoJson, "green", true, true).addTo(this.map)
      // })
      this.loadSingleBuilding()
    }

    if (this.featureId){

      // this.mapService.getLayerFeatureById$(this.featureId).subscribe( geoJson => {
      //   this.createGeoJSONLayer(geoJson, "green", true, false).addTo(this.map)
      // })
      this.loadSingleFeature()

    }

    if (!this.buildingId || !this.buildingIdsList)
      // this.fetchBuilding.next('')
      this.getFeatureList()

    let this_ = this
    let bounds = this_.map.getBounds()
    let zoom2distance = {
      7 : 125,
      8: 100,
      9: 80,
      10: 40,
      11: 25,
      12: 15,
      13: 12,
      14: 10,
      15: 5,
      16: 3,
      17: 1,
      18: 0.5,
      19: 0.2
    }
    this.map.on('dragend', function() {
      let newBounds = this_.map.getBounds()
      let dis = this_.calculateDistance(newBounds.getNorthEast(), bounds.getNorthEast())
      let zoom = this.getZoom()
      setTimeout(()=> {
          if (dis > zoom2distance[zoom] &&  zoom > 6) {
            bounds = newBounds
            this_.fetchBuilding.next('')
          }
        },
        50)
    });
    this.map.on('zoomend', function() {
      bounds = this_.map.getBounds()
      this_.fetchBuilding.next('')
    });

    // this.map.on('click', function(e){
    //   this_.addMarker(e)
    // });

    // this.map.on("draw:edited", function (e) {
      // const centroid = this_.getCentroid(this_.polygon.latlng)
      // this_.mapService.detectFeatureOnLayer$('ilot_dev', centroid).subscribe(result=>{
      //   console.log(result)
      // })
    // })

    this.map.on("draw:created", function (e) {
      if (this_.selectedBuildingLayer){
        this_.selectedBuildingLayer.removeFrom(this_.map)
      }
      this_.drawItems.clearLayers()
      if (this_.marker)
        this_.drawItems.removeLayer(this_.marker)
      this_.marker = e.layer
      this_.drawItems.addLayer(this_.marker)
      this_.updateClient(e, e.layer)
      const centroid = this_.getCentroid(this_.polygon.latlng)
      // this_.mapService.detectFeatureOnLayer$('ilot_dev', centroid).subscribe(result=>{
      //   console.log(result)
      // })
      this_.popupPosition(centroid)
      this_.marker.on('click', function(ev){
        this_.polygonOnClickHandler(ev)
      })
    })

    this.mapReady.emit(true)

  }


  calculateDistance(lat1,lat2){
    let dis = lat1.distanceTo(lat2)
    return dis / 1000 || 0
  }

  updateClient(e, layer){
    let coordinates = null
    let type = "Polygon"
    if (e.layerType || layer instanceof L.Polygon || layer instanceof L.Point){
      if (e.layerType === 'marker') type = "Point"
      if (layer?.feature?.geometry?.type == 'MultiPolygon') type = "MultiPolygon"
      coordinates = type === 'Point' ? layer.getLatLng() : (type === 'Polygon' ? layer.getLatLngs()[0] : layer.getLatLngs()[0][0] )
    }else{
      type = layer.feature.geometry.type
      let latLng = layer.feature.geometry.coordinates
      if (type === 'Point')
        coordinates = {lng: latLng[0], lat: latLng[1]}
      else if (type === 'Polygon')
        coordinates = latLng[0].map(m=> {
          return {"lng":m[0], "lat":m[1]}
        })
      else
        coordinates = latLng[0][0].map(m=> {
          return {"lng":m[0], "lat":m[1]}
        })
    }

    if (type === 'Point')
      this.selectedFeatureGeoJSON.emit(this.pointGeoJSON(coordinates))
    else {
      const geoJson = this.polygonGeoJSON(coordinates)
      this.selectedFeatureGeoJSON.emit(geoJson)
      // this.selectedFeatureBBOX.emit(this.getBbox(geoJson))
    }
    this.upsertPolygon(coordinates)
  }

  drawUpdated(e){
    let layers = e.layers
    let this_ = this
    if (this.selectedBuildingLayer){
      this.selectedBuildingLayer.removeFrom(this.map)
    }
    layers.eachLayer(layer => {
      this_.updateClient(e, layer)
    });
  }

  drawDeleted(e){
    this.marker = null
  }

  first = true
  getFeatureList(){
    if (this.loadBuildings || this.registered || this.withAttributes)
      this.showSpinner()
    let buildings
    // if (this.currentLocation)
    //   buildings = this.mapService.getNearestBuildings$(this.currentLocation)
    // else {
      // TODO below zoom < 10, dont load building (no sense to see tiny boxes)
      if (this.loadBuildings && (this.map?.getZoom() || 0) > 9) {
          buildings = this.mapService.getFeatureList$(this.getCurrentBbox(),
            this.map && (this.map?.getZoom() || 0) > 15, this.editBuilding || this.editFeature || this.editLot)
      }else
        buildings = of("")
    // }

    buildings.subscribe(geoJson => {
      setTimeout(()=>{
        if (this.layer){
          this.layer.clearLayers()
        }
        if (!this.layer) {
         this.layer = this.createGeoJSONLayer(geoJson)
          if (this.showBuildingLayer) {
            this.mapControl.addOverlay(this.layer, "RDF Buildings")
          }
        }

        if (this.loadBuildings && this.first){
          this.first = false
          this.layer.addTo(this.map)
        }

        this.layer.addData(geoJson)

        if (this.registered || this.withAttributes){
          let registerList$ = this.registered ? this.mapService.getRegistered$(this.getCurrentBbox(), this.jsonToParams(this.registeredFilter)) : of("")
          let withAttributesList$ = this.withAttributes ? this.mapService.getWithAttributes$(this.getCurrentBbox()) : of("")

          zip(registerList$, withAttributesList$).subscribe(result => {
            let registeredBuildings = result[0]
            let withAttributesBuildings = result[1]

            setTimeout(()=> {
              try {
                this.layerWithAttributes = this.createOverlay(this.layerWithAttributes, "Property TAX", withAttributesBuildings, this.withAttributes, "crimson")
                this.layerRegistred = this.createOverlay(this.layerRegistred, "Registered", registeredBuildings, this.registered, "green")
              }finally {
                this.hideSpinner()
              }
            }, 100)
          })
        }else{
          this.hideSpinner()
        }
      },100)
    })
  }

  createOverlay(layer, name, data, flag, color){
    if (layer){
      layer.clearLayers()
    }
    if (flag) {
      if (!layer) {
        layer = this.createGeoJSONLayer(data, color)
        layer.addTo(this.map)
        this.mapControl.addOverlay(layer, name)
      }
      layer.addData(data)
    }
    return layer
  }

  clearMap() {
    this.mapReady.emit(true)
  }

  fitBounds(geoJson) {
  }

  // onClick(event) {
  //   this.getFeatureData(event)
  // }

  popUp(latlng, infoHtml) {
    L.popup()
      .setLatLng(latlng)
      .setContent(infoHtml)
      .openOn(this.map)
  }

  // popUp(layer) {
  //   let data = layer.feature
  //   let infoHtml = '<div class="block"><div><b>Building:</b></div><div>' + data.properties.id + '</div>'
  //   infoHtml += '<div class="block"><div><b>Address:</b></div><div>' +
  //     (data.properties.street_id ? `${data.properties.street_name} ${data.properties.house_number}`  : 'N/A' ) +'</div>'
  //   infoHtml += '<div class="block"><div><b>Area:</b></div><div>' + data.properties.area + ' sqm</div>'
  //   infoHtml += '</div>'
  //   return infoHtml
  // }

  layer
  layerRegistred
  layerWithAttributes

  getFeatureData(e) {
    // if (this.layer) {
    //   this.layer.removeFrom(this.map)
    // }
    // let BBOX = this.getCurrentBbox()
    // let WIDTH = this.map.getSize().x
    // let HEIGHT = this.map.getSize().y
    // let X = Math.trunc(this.map.layerPointToContainerPoint(e.layerPoint).x)
    // let Y = Math.trunc(this.map.layerPointToContainerPoint(e.layerPoint).y)
    // this.loading = true
    // this.mapService.getFeatureInfo$(BBOX, WIDTH, HEIGHT, X, Y).subscribe(geoJson => {
    //   this.loading = false
    //   if (geoJson) {
    //     this.selectedBuildingId.emit(geoJson.id)
    //     this.layer = this.createGeoJSONLayer(geoJson).addTo(this.map)
    //   }
    // })
  }


  @HostListener('window:resize', ['$event'])
  sizeChange(event) {
    // this.fitBounds()
  }
  // prevLayer
  selectedBuildingLayer
  marker

  createGeoJSONLayer(geoJson, color = null, singleFeature = null, isBuilding = true, layerName = null){
    let this_ = this
    let layer = L.geoJSON(geoJson, {
      // @ts-ignore
      style: function (feature) {
          return this_.determineBuildingColor(feature, color, singleFeature, isBuilding)
        },
      pointToLayer: function (feature, latlng) {
        let markerColor = this_.determineBuildingColor(feature, color, singleFeature, isBuilding)
        return L.marker(latlng, {icon: this_.customMarker(markerColor.className)})
      },
      interactive: this.editFeature ||
        (this.editLot && layerName == this.sharedService.getLayer(this.sharedService.LAYER_LOT)) ||
        (isBuilding && !this.editFeature && !this.editLot)
    });

    // layer.bindTooltip(
    //   "dddd",
    //   {permanent: true, className: 'myClass', direction: 'center'}
    // ).openTooltip();
    if ((this.editBuilding && isBuilding) || (this.editFeature && !isBuilding) || (this.editLot && !isBuilding)) {
      layer.on('click', function(ev) {
        this_.editWindow(ev)
      });
    } else if (this.viewMode === 'taxProperty'){
      layer.on('click', function(ev) {
        alert('gamarjoba. me tax taxProperty var')
      })
    } else{
      layer.on('click', function(ev) {
        let data = ev.layer.feature.properties;
        this_.makeSelectedBuildingHighlighted(ev.layer);
        let popupHtml = `<table class="center-style mat-table mat-h5" style="width:100%"><tbody>
            <tr class="element-row mat-row">
                <td><b>ID</b></td>
                <td>${data.id}</td>
            </tr>`;
        if (data.street_id) {
          popupHtml += `<tr class="element-row mat-row">
                    <td><b>Address</b></td>
                    <td>${data.street_name} ${data.house_number ? data.house_number : ''}</td>
                </tr>`;
        }
        popupHtml += `</tbody></table>`;
        if (this_.registered) {
          this_.showSpinner();
          this_.mapService.getTinsByBuildingId$(data.id).subscribe(tins => {
            if (tins && tins.length) {
              popupHtml += '<hr/>';
            }
            popupHtml += '<table class="center-style mat-table mat-h3" style="width:100%"><tbody>';

            tins.forEach((t) => {
              // Extract of Payments
              t.groupByKeyYear.forEach((paymentDetails) => {
                if (paymentDetails.finalBalance < 0) {
                  popupHtml += `<tr class="element-row mat-row">
                                <td class="mat-cell cdk-column-name mat-column-name">${paymentDetails.name}</td>
                                <td class="mat-cell cdk-column-name mat-column-name" style="text-align: right;">${this_.balanceField(paymentDetails.finalBalance)}</td>
                            </tr>`;
                }
              });
              popupHtml += `<tr><td colspan="2"><hr/></td></tr>
                          <tr class="element-row mat-row"><td class="mat-cell cdk-column-name mat-column-name">
                            <a style="text-decoration: none" href="/tx_declarations?tin=${t.tin}" target="_blank" rel="noopener noreferrer">
                            ${t.tin} ${t.companyName}</a>
                          </td>
                          <td class="mat-cell cdk-column-name mat-column-name" style="text-align: right;">${this_.balanceField(t.overallBalance)}</td>
                          </tr>
                          <tr><td colspan="2"><hr/></td></tr>`;
            });
            popupHtml += '</tbody></table>';
            this_.hideSpinner();
            this_.popUp(ev.latlng, popupHtml);
          });
        } else {
          this_.popUp(ev.latlng, popupHtml);
        }
      });
    }
    return layer
  }

  editWindow(ev) {
    this.makeSelectedBuildingHighlighted(ev.layer);
    this.updateClient(ev, ev.layer);
    this.drawPolygons(true, ev);
    // this.popupPosition(ev.latlng);
    // DETECTION of iLot/lot
    if (this.editBuilding || this.editLot) {
      const latLng = this.getCentroid(this.polygon.latlng);
      if (!ev.latLng)  ev.latlng = latLng
      let props = ev.layer?.feature?.properties || {abstract_params: {}, attributes: {}};
      const municipality$ = this.mapService.detectFeatureOnLayer$(this.sharedService.getLayer(this.sharedService.LAYER_MUNICIPALITY), latLng);
      const district$ = this.mapService.detectFeatureOnLayer$(this.sharedService.getLayer(this.sharedService.LAYER_DISTRICT), latLng);
      const iLot$ = this.mapService.detectFeatureOnLayer$(this.sharedService.getLayer(this.sharedService.LAYER_ILOT), latLng);
      const lot$ = this.mapService.detectFeatureOnLayer$(this.sharedService.getLayer(this.sharedService.LAYER_LOT), latLng);
      const geoJson = this.polygonGeoJSON(this.polygon.latlng);
      const area$ = this.mapService.calculateArea$(geoJson);
      this.showSpinner();
      if (this.editBuilding) {
        zip(municipality$, district$, iLot$, lot$, area$).subscribe(detectionResult => {
          const municipality = detectionResult[0]?.length == 1 ? detectionResult[0]?.[0] : null
          const district = detectionResult[1]?.length == 1 ? detectionResult[1]?.[0] : null
          const iLotNum = detectionResult[2]?.length == 1 ? detectionResult[2]?.[0] : null
          const lotNum = detectionResult[3]?.length == 1 ? detectionResult[3]?.[0] : null
          const area = parseFloat(detectionResult[4] || props?.area || 0).toFixed(4)
          let popupHtml = `<table class="center-style mat-table mat-h5" style="width:100%"><tbody>
            <tr class="element-row mat-row">
                <td><b>Building ID</b></td>
                <td>${props.id || 'NEW'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Surface</b></td>
                <td>${area} &#13217;</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Municipality</b></td>
                <td>${municipality?.key || 'Cant Detect Municipality'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>District</b></td>
                <td>${district?.key || 'Cant Detect District'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Ilot#</b></td>
                <td>${iLotNum?.key || 'Cant Detect ILOT#'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Lot#</b></td>
                <td>${lotNum?.key || 'Cant Detect LOT#'}</td>
            </tr>
            `
            let buttonTitle = 'Edit'
            if (this.editRoleList.includes(this.user.role))
              buttonTitle = 'View'
            popupHtml += `<tr>
                <td colspan="2">
                    <button id="editAttributes" mat-raised-button color="primary">${buttonTitle}</button>&nbsp;`
            if (this.deleteRoleList.includes(this.user.role))
              popupHtml += `<button id="deleteBuilding" mat-raised-button color="warn">Delete</button>`
            popupHtml += `</div>
                </td>
            </tr>`

          props.attributes = {municipality: municipality, district: district, ilot: iLotNum, lot: lotNum}
          props.area = area
          this.selectedFeatureJson = props
          this.selectedBuildingDetails.next(props)
          this.hideSpinner()
          this.popUp(ev.latlng, popupHtml)
        });
      }
      if (this.editLot) {
        zip(municipality$, district$, iLot$, area$).subscribe(detectionResult => {
          const municipality = detectionResult[0]?.length == 1 ? detectionResult[0]?.[0] : null
          const district = detectionResult[1]?.length == 1 ? detectionResult[1]?.[0] : null
          const iLotNum = detectionResult[2]?.length == 1 ? detectionResult[2]?.[0] : null
          const lotNum = props?.key
          const area = parseFloat(detectionResult[3] || props?.area || 0).toFixed(4)
          let popupHtml = `<table class="center-style mat-table mat-h5" style="width:100%"><tbody>
            <tr class="element-row mat-row">
                <td><b>Lot ID</b></td>
                <td>${props.id || 'NEW'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Surface</b></td>
                <td>${area} &#13217;</td>
            </tr>
             <tr class="element-row mat-row">
                <td><b>Municipality</b></td>
                <td>${municipality?.key || 'Cant Detect Municipality'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>District</b></td>
                <td>${district?.key || 'Cant Detect District'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Ilot#</b></td>
                <td>${iLotNum?.key || 'Cant Detect. Please update feature coordinates or add corresponding ILOT#'}</td>
            </tr>
            <tr class="element-row mat-row">
                <td><b>Lot#</b></td>
                <td>${lotNum || 'Not defined'}</td>
            </tr>
            `
            let buttonTitle = 'Edit'
            if (this.editRoleList.includes(this.user.role))
              buttonTitle = 'View'
            popupHtml += `<tr>
                <td colspan="2">
                <button id="editAttributes" mat-raised-button color="primary">${buttonTitle}</button>
                </td>
            </tr>`
          props.attributes = {municipality: municipality, district:district, ilot: iLotNum, lot: lotNum}
          props.area = area
          this.selectedFeatureJson = props
          this.selectedBuildingDetails.next(props)
          this.hideSpinner()
          this.popUp(ev.latlng, popupHtml)
        })
      }
    }
  }

  makeSelectedBuildingHighlighted(layer){
    let data = layer.feature.properties;
    // if (!this.selectedBuildingLayer) {
    // } else {
    //   this.selectedBuildingLayer.setStyle({fillColor: 'red'});
    // }
    // layer.setStyle({fillColor: 'green'});
    // this.selectedBuildingLayer = layer
    if (this.selectedBuildingLayer) {
      this.selectedBuildingLayer.removeFrom(this.map);
    }
    this.selectedFeatureJson = data
    this.selectedBuildingDetails.next(data);
    this.selectedBuildingLayer = this.createGeoJSONLayer(layer.feature, 'blue', null).addTo(this.map);
  }

  balanceField(balance){
    if (balance < 0){
      return `<span style="color:red;">${this.numberThousands(balance)}</span>`
    }else{
      return `<span style="color:green;">${this.numberThousands(balance)}</span>`
    }
  }

  numberThousands(value){
    return value.toLocaleString('fr', {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  determineBuildingColor(feature, color, singleFeature, isBuilding){
    let data = feature.properties
    // ABSTRACT_PARAMS are used for building layer
    let abstractParam = data.abstract_params || data.attributes
    if (!abstractParam || (!data[`balance_state`] && !abstractParam['attributes'])){
      if (data.street_id && !singleFeature)
        return {color: "#4cbb17", fillRule: "nonzero", className: 'green-s'};
       else {
        if (!isBuilding) {
          if (data.layer?.startsWith('lot')){
            return {color: data['attributes']? "#2a6908": "#000000", fillOpacity: 0, weight: data['attributes']?10:5};
          }else {
            return {color: color ? color : "gray", fillOpacity: 0, weight: 5};
          }
        }else
          return {color: color ? color : "gray", fillRule: "nonzero"};
      }
    }else if (data[`balance_state`] > 0 || abstractParam['attributes']) {
      return {color: "#87f84e", fillRule: "nonzero", className: 'green'};
    }else if (data[`balance_state`] < 0) {
      return {color: "#e11846", fillRule: "nonzero", className: 'red'};
    }else {
      return {color: "gray", fillRule: "nonzero"};
    }
  }

  getCurrentBbox(){
    let west = this.map.getBounds().getSouthWest()
    let east = this.map.getBounds().getNorthEast()
    return west.lat + "," + west.lng + "," + east.lat + "," + east.lng
  }

  getBbox(gjon){
    const layer = L.geoJson(gjon).addTo(this.map)
    let west = layer.getBounds().getSouthWest()
    let east = layer.getBounds().getNorthEast()
    this.map.removeLayer(layer)
    return `${west.lng} ${west.lat},${east.lng} ${east.lat}`
  }

  pointGeoJSON(latlng) {
    return {
        'type': 'Point',
        'coordinates': [latlng.lng, latlng.lat]
    };
  }

  polygonGeoJSON(latlngs, ignoreRing = false) {
    let polygon = {
      'bbox': '',
      'type': 'Polygon',
      'coordinates': [latlngs.map(m=> [m.lng, m.lat])]
    };
    if (!ignoreRing && polygon.coordinates?.length > 0 ) {
      let p = polygon.coordinates[0]
      if (p[0] != p[p.length-1]){
        p.push(p[0])
      }
    }
    polygon.bbox = this.getBbox(polygon)
    return polygon
  }

  showSpinner(){
    this.spinner.show()
    window.dispatchEvent(new Event('resize'))
  }
  hideSpinner(){
    this.spinner.hide()
    window.dispatchEvent(new Event('resize'));
  }

  importCoordinatesFromShapeFile($event: any) {
    this.polygon.latlng = []
    this.populateShapeInstance({features: [$event]})
    const geoJson = this.polygonGeoJSON(this.polygon.latlng)
    this.selectedFeatureGeoJSON.emit(geoJson)

  }

  applyBoundaries(){
    this.onBoundariesApply.emit()
  }

  deleteBoundaries(){
    this.onBoundariesDelete.emit()
  }

  upsertPolygon(latLngs){
    this.polygon.latlng = []
    for (let i = 0; i < latLngs.length; i++) {
      let latLng = latLngs[i];
      let lat = parseFloat(latLng.lat);
      let lng = parseFloat(latLng.lng);
      this.polygon.latlng.push({lat: lat, lng: lng});
    }
  }

  populateShapeInstance($event){
    let $e = $event.features[0].geometry?.coordinates[0]
    this.polygon.latlng = []

    $e?.forEach(cor => {
      let lat = cor[1]
      let lng = cor[0]
      this.polygon.latlng.push({lat: parseFloat(lat), lng: parseFloat(lng)})
    });

    this.drawPolygons(false);
  }

  private popupPosition(latlng){
    const point = this.map.latLngToContainerPoint(latlng)
    this.sharedService.popupPosition(point)
  }

  private drawPolygons(ignoreZoom: boolean = false, sourceEvent = null): any {
    let bounds: LatLng[] = [];
    this.drawItems.clearLayers();
    let type = 'polygon';

    let latlngs: any = [];
    let this_ = this

    for (let j = 0; j < this.polygon.latlng.length; j++) {
      latlngs.push(new LatLng(this.polygon.latlng[j].lat, this.polygon.latlng[j].lng));
      bounds.push(new LatLng(this.polygon.latlng[j].lat, this.polygon.latlng[j].lng));
    }
    const layer = type == 'polygon' ? L.polygon(latlngs) : L.marker(latlngs);
    this.drawItems.addLayer(layer);

    if (sourceEvent) {
      layer.on('click', function(ev) {
        this_.polygonOnClickHandler(ev, sourceEvent)
      })
    }

    if (!ignoreZoom) {
      setTimeout(() => {
        if (bounds && bounds.length>0)
        this.map.fitBounds(L.latLngBounds(bounds));
      }, 400);
    }
  }

  polygonOnClickHandler(ev, sourceEvent= null){
    if (this.selectedBuildingLayer){
      this.selectedBuildingLayer.removeFrom(this.map)
    }
    // @ts-ignore
    ev.layer = {feature: this.drawItems.toGeoJSON(false)?.features[0]}
    if (sourceEvent)
      ev.layer.feature.properties = sourceEvent.layer?.feature?.properties
    this.editWindow(ev)
  }

  updateCoordinate() {
    this.drawPolygons(true)
    const geoJson = this.polygonGeoJSON(this.polygon.latlng, true)
    this.selectedFeatureGeoJSON.emit(geoJson)
  }

  deleteCoordinate( i: number) {
    this.polygon.latlng.splice(i, 1)
    this.updateCoordinate()
  }

  subscriptionConfirm: any
  deleteFeature(){
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: {
        text: 'MAP.CONFIRM_DELETE',
        emitter: this.sharedService.confirmDialogEmitter,
        obj: {},
        action: 'CONFIRM'
      }
    });

    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(val => {
      if (val) {
        this.deleteBoundaries()
      }
    })

    dialogRef.afterClosed().subscribe(() => {
      this.subscriptionConfirm.unsubscribe();
    });
  }

  deleteBuilding(){
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: {
        text: 'MAP.CONFIRM_DELETE_BUILDING',
        emitter: this.sharedService.confirmDialogEmitter,
        obj: {},
        action: 'CONFIRM'
      }
    });

    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(val => {
      if (val) {
          this.mapService.deleteBuilding$(this.selectedFeatureJson['fid']).subscribe( d => {
            let gJson = this.layer.toGeoJSON();
            gJson = gJson.features.filter(g => g.properties['fid'] != this.selectedFeatureJson['fid'])
            this.layer.clearLayers()
            this.layer.addData(gJson)
            this.clearAll()
            this.dialog.open(InformationDialogComponent,{
              width: "500px",
              disableClose: true,
              data: { text: "DIALOG.BUILDING_DELETE"},
            });
          })
      }
    })

    dialogRef.afterClosed().subscribe(() => {
      this.subscriptionConfirm.unsubscribe();
    });
  }

  getCentroid(arr) {
    let twoTimesSignedArea = 0;
    let cxTimes6SignedArea = 0;
    let cyTimes6SignedArea = 0;

    let length = arr.length

    let x = function (i) { return arr[i % length]['lat'] };
    let y = function (i) { return arr[i % length]['lng'] };

    for ( let i = 0; i < arr.length; i++) {
      let twoSA = x(i)*y(i+1) - x(i+1)*y(i);
      twoTimesSignedArea += twoSA;
      cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA;
      cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA;
    }
    let sixSignedArea = 3 * twoTimesSignedArea;

    return new LatLng(cxTimes6SignedArea / sixSignedArea,cyTimes6SignedArea / sixSignedArea)
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {

    if (event.target && event.target['id']) {

      switch (event.target['id']) {
        case "editAttributes":
          this.map.closePopup()
          this.onEditAttributes.emit()
          break;
        case "deleteBuilding":
          this.deleteBuilding()
          break;
        case "rame":
          this.layer.getPopup().update()
          break;
        default:
          // this.selectedBuildingLayer?.removeFrom(this.map)
          // this.drawItems?.clearLayers()
      }
    }
  }

  getShapeFileAttributes($e: any) {
    /**
     *  EXAMPLE
     */
    // setTimeout(
    //   ()=> {
    //     this.uploadMappingBody = {
    //       keyColumn: "status_id",
    //       mapping: {
    //         "lot": "status_id",
    //         "ilot": "code"
    //       }
    //     }
    //     setTimeout(()=>{this.remoteShapeFileImport.upload()}, 50)
    //   }, 2000)
    this.onShapeFileAttributes.next($e)
  }

  shapeFileUploaded($e:any){
    this.onShapeFileUpload.next($e)
    if (this.editLot)
      this.loadLayers()
  }

  showCoord = false
  showCoordinates(){
    this.showCoord = !this.showCoord
  }

  jsonToParams(json){
    if (!json) return ''
    return new URLSearchParams(json).toString()
  }

  loadSingleBuilding(automaticallyOpenPopup = false) {
    try {
      this.mapService.getFeatureById$(this.buildingId).subscribe(geoJson => {
        let singleBuilding = this.createGeoJSONLayer(geoJson, 'green', true, true);
        singleBuilding.addTo(this.map);
        try {
          if (automaticallyOpenPopup)
            singleBuilding?.fire('click', {layer: singleBuilding.getLayers()?.[0]});
          setTimeout(() => {
            this.map.fitBounds(singleBuilding?.getBounds());
          }, 50);
        } catch (e) {
          console.error(e);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  loadSingleFeature(automaticallyOpenPopup = false) {
    try {
      this.mapService.getLayerFeatureById$(this.featureId).subscribe(geoJson => {
        let singleBuilding = this.createGeoJSONLayer(geoJson, 'green', true, false);
        singleBuilding.addTo(this.map);
        try {
          if (automaticallyOpenPopup)
            singleBuilding?.fire('click', {layer: singleBuilding.getLayers()?.[0]});
          setTimeout(() => {
            this.map.fitBounds(singleBuilding?.getBounds());
          }, 50);
        } catch (e) {
          console.error(e);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

}
